import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastProvider } from "./components/Toast";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import SettingsPage from "./pages/SettingsPage";
import InternalMessagesPage from "./pages/InternalMessagesPage";
import AuditLogPage from "./pages/AuditLogPage";
import SentEmailsPage from "./pages/SentEmailsPage";
import MailerDashboard from "./pages/mailer/MailerDashboard";

function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/mailer" element={<MailerDashboard />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/internal-messages" element={<InternalMessagesPage />} />
          <Route path="/sent" element={<SentEmailsPage />} />
          <Route path="/audit-log" element={<AuditLogPage />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;
